import React, { useState, useEffect, useRef  } from 'react'
import { setLocal as set, getLocal as get } from '../../common/utils'
import { custom } from 'devextreme/ui/dialog';
import { postUserLog } from '../../actions/common'

export default ({ maxMin, update, siteId}) => {
    const [timeVal, setTimeVal] = useState('00:00');
    const [timeObj, setTimeObj] = useState(null)
    const [continueMeeting, setContinueMeeting] = useState(false)
    const [isTimerRunning, setIsTimerRunning] = useState(false)
    const startRef = useRef(null);
    const btnRef = useRef(null);

    const minVal = 'minVal_' + siteId;
    const secVal = 'secVal_' + siteId;
    const isMeetingRunning = 'isMeetingRunning_' + siteId;


    function stopTimer() {
        postUserLog({ event: 'Meeting timer stop', data: { action: 'Dashboad meeting timer stopped', module: 'Digital Tier', section: 'Header', siteUId: siteId, widget: 'Dashboad Meeting Timer', } })
        set(isMeetingRunning, false)
        clearInterval(timeObj);
        setIsTimerRunning(false)
    }

    function saveStopTime() {
        //let min = parseInt(get('minVal'))
        //let sec = parseInt(get(secVal))
        let data = {
            "siteId": "",
            "tierId": "",
            "isStart": 0,
            "Seconds": get(secVal),
            "Minutes": get(minVal) 
        }
        update(data)
    }

    function startTimer() {
        postUserLog({ event: 'Meeting timer start', data: { action: 'Dashboard meeting timer started', module: 'Digital Tier', section: 'Header', siteUId: siteId, widget: 'Dashboad Meeting Timer', } })
        const timerRef = setInterval(timerCycle, 1000);
        set(isMeetingRunning, true)
        setTimeObj(timerRef)
        setIsTimerRunning(true)
        let data = {
            "siteId": "",
            "tierId": "",
            "isStart": 1
        } 
        update(data)
        
    }

    function maxMinReached() {
        btnRef.current.click();
        
        let myDialog = custom({
            title: "Meeting exceeding",
            messageHtml: "Time's up!",
            buttons: [{
                text: "Continue",
                onClick: (e) => {
                    return { buttonText: e.component.option("text") }
                }
            },
                {
                    text: "End",
                    onClick: (e) => {
                        return { buttonText: e.component.option("text") }
                    }
                },
                
            ]
        });
        myDialog.show().then((res) => {
            if (res.buttonText === 'Continue') {
               
                setContinueMeeting(true)
                startRef.current.click();
            } else {
                saveStopTime()
                resetTimer();
            }
        });

    }

 
    function timerCycle() {
        let min = parseInt( get(minVal))
        let sec = parseInt(get(secVal))

            sec = sec + 1;

            if (sec == 60) {
                min = min + 1;
                sec = 0;
        }

        
        if (!continueMeeting) {
            if (min == maxMin && sec == 0) {
                if (sec < 10 || sec == 0) {
                    sec = '0' + sec;
                }
                if (min < 10 || min == 0) {
                    min = '0' + min;
                }
                set(minVal, min)
                set(secVal, sec)
                setTimeVal(min + ':' + sec)
                maxMinReached()
                return;
            }

            if (min == maxMin && sec > 0) {

                return;
            }

            if (min > maxMin) {
                maxMinReached()
                return;
            }
        }


        set(minVal, min)
        set(secVal, sec)

        if (sec < 10 || sec == 0) {
            sec = '0' + sec;
        }
        if (min < 10 || min == 0) {
            min = '0' + min;
        }

        setTimeVal(min + ':' + sec)
 
    }

    function resetTimer() {
        postUserLog({ event: 'Meeting timer reset', data: { action: 'Dashboard meeting timer reset', module: 'Digital Tier', section: 'Header', siteUId: siteId, widget: 'Dashboad Meeting Timer',  } })
        setTimeVal("00:00")
        set(minVal, 0)
        set(secVal, 0)
        setIsTimerRunning(false)
        setContinueMeeting(false)
        set(isMeetingRunning, false)
        if (timeObj)
            clearInterval(timeObj)
    }

    useEffect(() => {
        let min = get(minVal)
        let sec = get(secVal)
       
        if (!min) {
            min = 0;
            set(minVal, 0)
        }
            
        if (!sec) {
            sec = 0;
            set(secVal, 0)
        }
           

        if (sec < 10 || sec == 0) {
            sec = '0' + sec;
        }
        if (min < 10 || min == 0) {
            min = '0' + min;
        }

        setTimeVal(min+':'+sec)

        
                
        

        if (get(isMeetingRunning) === 'true') {
            startTimer()
        }
        
    }, [])

    return (
        
        <div className="timer-box ">
           
            <span id="min" className="meet-timer">{timeVal}</span>

            {isTimerRunning && <i ref={btnRef} title="Pause" onClick={stopTimer} className="fas fa-pause"></i>}
            
            {!isTimerRunning && <i ref={startRef} title="Play" onClick={()=>startTimer()} className="fas fa-play"></i>}
            
            <i onClick={resetTimer} title="Reset" className="fas fa-undo"></i>
            

        </div>
    )
}